<template>
  <div class="gen-viewer">
    <div class="gen-card">
      <div v-if="item.coverUrl" class="gen-cover-wrap">
        <img class="gen-cover" :src="item.coverUrl" alt="" referrerpolicy="no-referrer" />
      </div>
      <div class="gen-body">
        <div class="gen-platform">{{ platformLabel }}</div>
        <h3 class="gen-title">{{ item.title }}</h3>
        <p class="gen-content">{{ item.content || '暂无正文' }}</p>
        <div class="gen-stats">
          <span v-if="item.views">阅读 {{ formatCount(item.views) }}</span>
          <span>赞 {{ formatCount(item.likes) }}</span>
          <span>评 {{ formatCount(item.comments) }}</span>
          <span v-if="item.collects">藏 {{ formatCount(item.collects) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { formatCount } from './normalizeContent'

const props = defineProps({
  item: { type: Object, required: true },
})

const platformLabel = computed(() => ({
  toutiao: '头条',
  baijiahao: '百家号',
  bilibili: '哔哩哔哩',
  kuaishou: '快手',
}[props.item?.platform] || props.item?.platform || '作品预览'))
</script>

<style scoped>
.gen-viewer { display: flex; justify-content: center; padding: 8px 0; }
.gen-card {
  width: min(520px, 100%);
  background: #fff;
  border: 1px solid #e8ecf3;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(34, 52, 84, 0.06);
}
.gen-cover-wrap { background: #f5f7fa; }
.gen-cover {
  width: 100%;
  max-height: 260px;
  object-fit: cover;
  display: block;
}
.gen-body { padding: 16px 18px 18px; }
.gen-platform {
  font-size: 12px;
  color: #326cf4;
  font-weight: 600;
  margin-bottom: 8px;
}
.gen-title {
  margin: 0 0 10px;
  font-size: 18px;
  line-height: 1.4;
  color: #172033;
}
.gen-content {
  margin: 0;
  white-space: pre-wrap;
  font-size: 14px;
  line-height: 1.7;
  color: #4a5568;
}
.gen-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 14px;
  font-size: 12px;
  color: #8590a6;
}
</style>
